module.exports = __webpack_public_path__ + "img/one.6bab6cae.png";